export const GET_EVENTS = "getEvents";
export const CREATE_EVENT = "createEvent"
export const UPDATE_EVENT = "updateEvent"
export const DELETE_EVENT = "deleteEvent"